export type SiteLang = 'de' | 'en' | 'tr'

// Routes that have fully-localized /en and /tr variants. As more pages are
// translated, add their German path here and the locale-aware links across
// the site (nav, footer, CTAs) start pointing at the translated version.
const LOCALIZED = new Set<string>([
  '/', '/pricing', '/signin', '/signup',
  // product / feature pages
  '/reservierungen', '/reservierungen/digitales-reservierungsbuch',
  '/reservierungs-tool', '/bestellungen',
  '/planung', '/planung/tischplan', '/planung/anzahlung',
  '/restaurant-webseite', '/marketing/gastbewertungen',
  '/service', '/faq', '/use-cases', '/integrationen',
])

/**
 * Locale-aware internal path. For German (the default) the href is returned
 * unchanged. For en/tr, a path that has a localized variant is prefixed with
 * the locale base (e.g. `/pricing` → `/en/pricing`, `/` → `/tr`); query
 * strings are preserved (`/signup?plan=pro` → `/en/signup?plan=pro`). Paths
 * without a localized variant fall back to the German page.
 */
export function lp(href: string, lang: SiteLang): string {
  if (lang === 'de') return href
  const [path, query] = href.split('?')
  if (!LOCALIZED.has(path)) return href
  const base = path === '/' ? `/${lang}` : `/${lang}${path}`
  return query ? `${base}?${query}` : base
}
